import Resources from '../../helpers/resources';
import { ERROR_DETECTED } from '../upf-assign/upf-assign-actions';
import { getLocale } from '../../helpers/locale';
import { getTeacherAuthToken } from '../../helpers/utils';
import { CLASSROOM, GROUP } from '../../components/doughnuts-inner/doughnuts-inner-hooks';

export const LEARNING_GAPS_REQUEST = 'LEARNING_GAPS_REQUEST';
export const LEARNING_GAPS_FAILURE = 'LEARNING_GAPS_FAILURE';
export const GET_LEARNING_GAPS_SUCCESS = 'GET_LEARNING_GAPS_SUCCESS';
export const GET_LEARNING_GAPS_PER_STUDENT_SUCCESS = 'GET_LEARNING_GAPS_PER_STUDENT_SUCCESS';

export const ASSIGN_LEARNING_GAPS_REQUEST = 'ASSIGN_LEARNING_GAPS_REQUEST';
export const ASSIGN_LEARNING_GAPS_SUCCESS = 'ASSIGN_LEARNING_GAPS_SUCCESS';
export const ASSIGN_LEARNING_GAPS_FAILURE = 'ASSIGN_LEARNING_GAPS_FAILURE';

export const CLEAR_LEARNING_GAPS = 'CLEAR_LEARNING_GAPS';
export const UPDATE_LEARNING_JOURNEYS_INDEX = 'UPDATE_LEARNING_JOURNEYS_INDEX';
export const UPDATE_LEARNING_JOURNEYS_STATE = 'UPDATE_LEARNING_JOURNEYS_STATE';

export const clearLearningGaps = () => ({
  type: CLEAR_LEARNING_GAPS
});

export const updateLearningJourneysByIndex = (studentId, index, state) => ({
  type: UPDATE_LEARNING_JOURNEYS_INDEX,
  studentId,
  index,
  state
});

export const updateLearningJourneysByState = (currentState, nextState, studentId) => ({
  type: UPDATE_LEARNING_JOURNEYS_STATE,
  studentId,
  currentState,
  nextState
});

export const getUpfPreview = async ({
  productId,
  courseId,
  courseVersion,
  learningJourneyId
}) => {
  try {
    const response = await Resources.previewUpf
      .post()
      .withBody({
        productId,
        courseId,
        courseVersion,
        learningJourneyId
      })
      .send();
    if (response.data) {
      const { assignmentId } = response.data;
      const upfBaseUrl = window._env_.UPFBaseUrl;
      // eslint-disable-next-line max-len
      return `${upfBaseUrl}?authToken=${getTeacherAuthToken()}&locale=${getLocale()}&assignmentId=${assignmentId}&isPreview=true&newContent=true`;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const assignLearningGaps = ({
  productId,
  classroomId,
  studentProfileIds,
  learningJourneys
}) => async (dispatch) => {
  try {
    dispatch({ type: ASSIGN_LEARNING_GAPS_REQUEST });
    const response = await Resources.assignLearningGaps
      .post()
      .withBody({
        productId,
        classroomId,
        studentProfileIds,
        learningJourneys
      })
      .raw()
      .send();
    if (response.status === 204 || response.status === 200) {
      dispatch({ type: ASSIGN_LEARNING_GAPS_SUCCESS });
      return true;
    }
    dispatch({ type: ASSIGN_LEARNING_GAPS_FAILURE });
    return false;
  } catch (error) {
    dispatch({
      type: ERROR_DETECTED,
      payload: error
    });
    return false;
  }
};

export const getLearningGaps = requestData => async (dispatch) => {
  try {
    dispatch({
      type: LEARNING_GAPS_REQUEST
    });
    const response = await Resources.getLearningGaps
      .post()
      .withBody(requestData)
      .send();

    if (response.data.resultType === CLASSROOM && requestData.groupId !== 0) {
      response.data.resultType = GROUP;
    }
    dispatch({
      type: GET_LEARNING_GAPS_SUCCESS,
      payload: response.data
    });
  } catch (err) {
    dispatch({
      type: LEARNING_GAPS_FAILURE
    });
  }
};

export const getLearningGapsPerStudent = requestData => async (dispatch) => {
  try {
    dispatch({
      type: LEARNING_GAPS_REQUEST
    });
    const response = await Resources.getLearningGapsPerStudent
      .post()
      .withBody(requestData)
      .send();

    dispatch({
      type: GET_LEARNING_GAPS_PER_STUDENT_SUCCESS,
      payload: response.data
    });
  } catch (err) {
    dispatch({
      type: LEARNING_GAPS_FAILURE,
      payload: err
    });
  }
};

export const assignLearningGapsPerStudent = ({
  productId,
  classroomId,
  students
}) => async (dispatch) => {
  try {
    dispatch({ type: ASSIGN_LEARNING_GAPS_REQUEST });
    const response = await Resources.assignLearningGapsPerStudent
      .post()
      .withBody({
        productId,
        classroomId,
        students
      })
      .raw()
      .send();
    if (response.status === 204 || response.status === 200) {
      dispatch({ type: ASSIGN_LEARNING_GAPS_SUCCESS });
      return true;
    }
    dispatch({ type: ASSIGN_LEARNING_GAPS_FAILURE });
    return false;
  } catch (error) {
    dispatch({
      type: ERROR_DETECTED,
      payload: error
    });
    return false;
  }
};
